import { render, staticRenderFns } from "./case_class.vue?vue&type=template&id=050986a2&scoped=true"
import script from "./case_class.vue?vue&type=script&lang=js"
export * from "./case_class.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050986a2",
  null
  
)

export default component.exports